import React from "react";
import { ArrowBack } from "@mui/icons-material";
import { Button as MuiButton, Grid } from "@mui/material";
import { Button } from "@platform/design-system";

const ClientBtnSection = ({
  mainBtn,
  mainAction = () => {},
  mainDisabled = false,
  secBtn,
  secVariant,
  secHasIcon,
  loading = false,
  secAction = () => {},
}) => (
  <Grid container size={12} justifyContent="space-between" mt={3}>
    {/* TODO(ds-button): needs manual review — dynamic variant prop (secVariant) plus color="brandPrimary" cannot be mapped statically */}
    <MuiButton
      color="brandPrimary"
      variant={secVariant}
      startIcon={secHasIcon ? <ArrowBack /> : null}
      onClick={secAction}
    >
      {secBtn}
    </MuiButton>
    <Button
      variant="primary"
      onClick={mainAction}
      disabled={mainDisabled}
      loading={loading}
    >
      {mainBtn}
    </Button>
  </Grid>
);

export default ClientBtnSection;
